import { from } from "rxjs";
import { filter, map, switchMap } from "rxjs/operators";
import { isActionOf } from "typesafe-actions";
import { catchAsyncActionErrors } from "./api";
import api from "../api";
import { fetchSpeakers } from "../actions/engine";
const fetchSpeakersEpic = action$ => action$.pipe(filter(isActionOf(fetchSpeakers.request)), switchMap(_request => from(api.fetchSpeakers()).pipe(map(fetchSpeakers.success), catchAsyncActionErrors(action$, fetchSpeakers))));
export default fetchSpeakersEpic;
